/**
 * Требования к паролю. Конфиг общий: клиент проверяет им форму до отправки
 * (чтобы не гонять человека на сервер за очевидной ошибкой), сервер — при
 * регистрации, и его проверка единственная, которой можно верить.
 *
 * Правила намеренно сделаны по современным рекомендациям (NIST SP 800-63B), а
 * не по привычке из нулевых:
 *  - длина решает больше, чем «обязательно цифра и спецсимвол»: требования к
 *    составу заставляют людей делать Password1! и записывать пароли, но
 *    почти не увеличивают реальную стойкость;
 *  - зато отсекаются самые частые пароли и пароль, повторяющий свою же почту —
 *    это первое, что подставляет любой перебор;
 *  - верхняя граница нужна не для стойкости, а против нагрузки: пароль идет в
 *    scrypt, и мегабайтная строка стала бы бесплатным способом занять сервер.
 */

export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 200;

// Самые частые пароли и очевидные для нашей игры варианты. Список короткий
// сознательно: полноценная проверка по утечкам — это внешний сервис, а здесь
// нужен дешевый отсев того, что подбирают первым
const COMMON_PASSWORDS = new Set([
  '0123456789', '1234567890', '12345678910', '123456789012',
  'qwertyuiop', 'qwerty12345', 'qwerty123456', 'password12', 'password123',
  'password1234', 'пароль1234', 'strategikon', 'strategikon1', 'strategikon123',
  'стратегикон', 'administrator', 'iloveyou123', 'letmein1234',
]);

/**
 * Проверка пароля.
 * @param {string} password
 * @param {Object} [options]
 * @param {string} [options.email] — пароль не должен повторять имя ящика
 * @returns {{isValid: boolean, error: string|null}} error — готовый текст для показа
 */
export const validatePassword = (password, {email} = {}) => {
  const value = typeof password === 'string' ? password : '';

  if (value.length < PASSWORD_MIN_LENGTH) {
    return {isValid: false, error: `Пароль должен быть не короче ${PASSWORD_MIN_LENGTH} символов`};
  }
  if (value.length > PASSWORD_MAX_LENGTH) {
    return {isValid: false, error: `Пароль должен быть не длиннее ${PASSWORD_MAX_LENGTH} символов`};
  }
  // Пробелы в пароле разрешены (парольные фразы — это хорошо), но пароль из
  // одних пробелов паролем не является
  if (!value.trim()) {
    return {isValid: false, error: 'Пароль не может состоять из одних пробелов'};
  }
  if (COMMON_PASSWORDS.has(value.toLowerCase())) {
    return {isValid: false, error: 'Этот пароль слишком распространен — придумай другой'};
  }

  const emailLocalPart = String(email || '').split('@')[0].toLowerCase();
  if (emailLocalPart.length >= 3 && value.toLowerCase().includes(emailLocalPart)) {
    return {isValid: false, error: 'Пароль не должен повторять адрес почты'};
  }

  return {isValid: true, error: null};
};

// Текст под полем ввода — то же правило словами
export const PASSWORD_REQUIREMENTS_HINT = `Не короче ${PASSWORD_MIN_LENGTH} символов`;
